import { useEffect, useState } from 'react';
import isEqual from 'hs-lodash/isEqual';
export const useDisplayedData = (data, {
  loading,
  initialOnly,
  parameters
}) => {
  const [displayedData, setDisplayedData] = useState();
  const [currentParams, setCurrentParams] = useState();
  // we tried to use 'useMemo' here but there is no easy way
  // to just keep the last 'non-loading' value
  useEffect(() => {
    if (initialOnly && loading && !isEqual(currentParams, parameters)) {
      // clears params and data if the params change while loading
      // this is to prevent displaying old data while loading different tabs or filters
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setDisplayedData(undefined);
    } else if (!loading && !isEqual(data, displayedData)) {
      // for situations where we only display the initial load (ghosts) we
      // reset the displayed data if the page parameters (page number, filters, etc) change
      if (initialOnly && !!displayedData && isEqual(currentParams, parameters)) return;
      setDisplayedData(data);
      setCurrentParams(parameters);
    }
  }, [loading, data, displayedData, initialOnly, currentParams, parameters]);
  return displayedData;
};